import { useMemo } from "react";

import { selectBaseDataTaskRecords } from "fond/redux/baseDataTasks";
import { Store } from "fond/types";
import { useAppSelector } from "fond/utils/hooks";

import { BaseDataTasks, getOwnedBaseDataTasks } from "./tasks";

const selectUploads = (state: Store) => state.project.projects[state.project.projectId]?.uploads;

/** Return the task of each base data row whose flyout started one, keyed by that row. */
export const useOwnedBaseDataTasks = (): BaseDataTasks => {
  const records = useAppSelector(selectBaseDataTaskRecords);
  const uploads = useAppSelector(selectUploads);
  const polygon = useAppSelector((state) => state.project.polygon);

  return useMemo(() => getOwnedBaseDataTasks(records, { uploads, polygon }), [records, uploads, polygon]);
};
